/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';
import { slug } from '../';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import Link from 'flarum/common/components/Link';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.lib.achievement_level`;
export default class AchievementLevel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  callFunctionOrDefault(obj, funcName, defaultValue) {
    if (typeof obj[funcName] === 'function') {
      return obj[funcName]() ? obj[funcName]() : defaultValue;
    }
  }
  propertyDefaults = {
    backgroundColor: 'var(--body-bg-shaded)',
    iconColor: 'inherit',
    levelBgColor: 'var(--text-color)',
    levelTextColor: 'var(--body-bg)',
    image: null,
    icon: null,
    level: null,
    name: null,
    description: null
  };
  view() {
    const {
      achievementLevel,
      more,
      link,
      actions,
      showDesc
    } = this.attrs;
    if (!achievementLevel) {
      return null;
    }
    const props = Object.keys(this.propertyDefaults).reduce((acc, prop) => {
      acc[prop] = this.callFunctionOrDefault(achievementLevel, prop, this.propertyDefaults[prop]);
      return acc;
    }, {});
    const {
      backgroundColor,
      iconColor,
      levelBgColor,
      levelTextColor,
      image,
      icon,
      level,
      name,
      description
    } = props;
    return m("div", {
      className: `AchievementLevel ${Number.isInteger(more) ? 'AchievementLevel--more' : ''}`,
      style: {
        '--achievement-bg': backgroundColor,
        '--achievement-icon-color': iconColor,
        '--achievement-level-bg-color': levelBgColor,
        '--achievement-level-text-color': levelTextColor
      }
    }, m("div", {
      className: "AchievementLevel-shape"
    }, m("div", {
      className: "AchievementLevel-iconContainer"
    }, image && m("div", {
      className: "AchievementLevel-image",
      style: {
        '--achievement-image': `url("${image}")`
      }
    }), !image && icon && m(Icon, {
      name: icon
    }), Number.isInteger(more) && link && m(Link, {
      className: "AchievementLevel-more",
      href: link
    }, more > 0 ? t(`${prfx}.more`, {
      count: more
    }) : null)), level && m("div", {
      className: "AchievementLevel-level"
    }, level)), m("div", {
      className: "AchievementLevel-infos"
    }, name && m("div", {
      className: "AchievementLevel-name"
    }, name), showDesc && description && m("div", {
      className: "AchievementLevel-description"
    }, description)), actions && m("div", {
      className: "AchievementLevel-actions"
    }, actions));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/components/AchievementLevel', AchievementLevel);